<template>
  <div class="v-radio">
    <label class="v-radio__wrapper">
      <input class="v-radio__input" type="radio" v-bind="$attrs" v-on="inputListeners" :checked="checked" @invalid="onInvalid" @change.stop="onChange" />
      <div class="v-radio__radio"></div>
      <span class="v-radio__label">{{placeholder}}</span>
    </label>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    placeholder: {
      type: String,
      default: null
    },
    checked: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    inputListeners() {
      return {
        ...this.$listeners,
        input: event => event.preventDefault(),
        change: event => this.$emit("input", event)
      };
    }
  },
  methods: {
    onInvalid(event) {
      this.$parent.$emit("radio-invalid");
    },
    onChange(event) {
      this.$parent.$emit("radio-change");
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-radio {
  cursor: default;

  &__wrapper {
    position: relative;
    display: flex;
    align-items: center;
    user-select: none;
  }

  &__input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;

    &:checked ~ .v-radio__radio {
      background: theme-color("focus");
      border-color: theme-color("focus");

      &::before {
        background: #fff;
      }
    }

    &:checked:disabled ~ .v-radio__radio {
      background: #fff;
      border-color: theme-color("border");
      cursor: not-allowed;

      &::before {
        background: theme-color("border");
      }
    }

    &:disabled ~ .v-radio__radio {
      cursor: not-allowed;
    }

    &:checked ~ .v-radio__label {
      color: inherit;
    }

    &:disabled ~ .v-radio__label {
      color: theme-color("border");
      cursor: not-allowed;
    }
  }

  &__radio {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    flex-basis: 24px;
    flex-shrink: 0;
    border-radius: 100%;
    background: #fff;
    border: 1px solid theme-color("border");

    &::before {
      content: "";
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 100%;
    }
  }

  &__label {
    margin-left: $spacer;
    color: theme-color("placeholder");
  }
}
</style>
